import { proxy } from "valtio";
import { enjoySettings } from "./enjoySettings.js";
import { superliteSettings } from "./superliteSettings.js";

const state = proxy({
  active: "B",

  // Must return the actual proxy, not a snapshot or wrapped object
  get current() {
    // console.log("Settings: ", this.active);
    return this.active === "A" ? enjoySettings : superliteSettings;
  },
});

export { state };
